import { Document, Page, pdfjs, Thumbnail } from 'react-pdf'

// react-pdf's entry sets `GlobalWorkerOptions.workerSrc = 'pdf.worker.mjs'` (a bare,
// page-relative path) as an import side effect. When react-pdf is code-split into a
// lazily loaded chunk it evaluates *after* an entry-level override and clobbers it,
// making the worker resolve against the current route instead of the bundled asset.
// Re-applying it here — in the single module every PDF consumer imports from —
// guarantees our value runs after react-pdf's default in whatever chunk it lands in.
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString()

export { Document, Page, Thumbnail, pdfjs }
